import { VorKommissionierungConfig } from '../kommissionierung.shared';
import { KopfkommResult } from '../store';
import { KommissionsauftragKopf } from '../types/kommissionsauftrag';

/** Flow 1 only runs for a normal picking order, with the switch on and a scan the backend identified. */
export function shouldOfferScanConfirmation(
  config: VorKommissionierungConfig | null | undefined,
  result: KommissionsauftragKopf | KopfkommResult | null | undefined,
  order: KommissionsauftragKopf | null | undefined
): result is KopfkommResult {
  return (
    !!config?.showConfirmationAfterScan &&
    !!result &&
    'kopfkomm' in result &&
    !!result.bewekommscan?.id &&
    order?.mischpalette !== true
  );
}
